import fetch from 'auth/FetchInterceptor';

const UserService = {};

UserService.getFullMerchantData = function (data) {
  return fetch({
    url: '/v1/merchant/getFullMerchantData',
    method: 'get',
  });
};

UserService.getMerchantProfile = function () {
  return fetch({
    url: '/v1/merchant/getMerchantProfile',
    method: 'get',
  });
};

UserService.getUserMerchants = function () {
  return fetch({
    url: '/v1/merchant/getUserMerchants',
    method: 'get',
  });
};

UserService.getUser = function () {
  return fetch({
    url: '/v1/user/getUser',
    method: 'get',
  });
};

UserService.updateMerchantBankDetails = function (data) {
  return fetch({
    url: '/v1/merchant/upsertMerchantBankDetails',
    method: 'post',
    data,
  });
};

UserService.createPaymentRequest = function (data) {
  return fetch({
    url: '/v1/merchant/createPaymentRequest',
    method: 'post',
    data,
  });
};

UserService.getPaymentRequests = function (params = {}) {
  const query = new URLSearchParams();
  if (params.status != null && params.status !== '') {
    query.set('status', params.status);
  }
  if (params.page != null && params.page >= 1) {
    query.set('page', String(params.page));
  }
  if (params.page_size != null && params.page_size >= 1) {
    query.set('page_size', String(params.page_size));
  }
  if (params.search != null && String(params.search).trim() !== '') {
    query.set('search', String(params.search).trim());
  }
  if (params.sort != null && params.sort !== '') {
    query.set('sort', String(params.sort));
  }
  if (params.order != null && params.order !== '') {
    query.set('order', String(params.order));
  }
  const qs = query.toString();
  return fetch({
    url: `/v1/merchant/getPaymentRequests${qs ? `?${qs}` : ''}`,
    method: 'get',
  });
};

UserService.getPaymentRequest = function (id) {
  return fetch({
    url: `/v1/merchant/payment-requests/${id}`,
    method: 'get',
  });
};

UserService.deletePaymentRequest = function (id) {
  return fetch({
    url: `/v1/merchant/payment-requests/${id}`,
    method: 'delete',
  });
};

UserService.updatePaymentRequest = function (id, data) {
  return fetch({
    url: `/v1/merchant/payment-requests/${id}`,
    method: 'put',
    data,
  });
};

UserService.getMerchantTripsForPayment = function (
  merchantId,
  search,
  includeTripId
) {
  const query = new URLSearchParams();
  if (merchantId != null && merchantId !== '') {
    query.set('merchant_id', String(merchantId));
  }
  if (search != null && String(search).trim() !== '') {
    query.set('search', String(search).trim());
  }
  if (includeTripId != null && includeTripId !== '') {
    query.set('include_trip_id', String(includeTripId));
  }
  const qs = query.toString();
  return fetch({
    url: `/v1/merchant/getMerchantTripsForPayment${qs ? `?${qs}` : ''}`,
    method: 'get',
  });
};

UserService.getAllMerchants = function () {
  return fetch({
    url: '/v1/merchant/getAllMerchants',
    method: 'get',
  });
};

UserService.approvePaymentRequest = function (id, paymentReceipt, amountPaidSgd) {
  return fetch({
    url: '/v1/merchant/admin/approve-payment-request',
    method: 'post',
    data: { id, payment_receipt: paymentReceipt, amount_paid_sgd: amountPaidSgd },
  });
};

UserService.rejectPaymentRequest = function (id, rejectionReason) {
  return fetch({
    url: '/v1/merchant/admin/reject-payment-request',
    method: 'post',
    data: { id, rejection_reason: rejectionReason },
  });
};

export default UserService;
